import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { VolunteerOrganization } from "../volunteer-organization";
import { VolunteerOrganizationContactEntityConfig } from "./config";
import { VolunteerOrganizationContactFilters } from "./filters";
import { VolunteerOrganizationContactMethods } from "./methods";

@HyperEntity(
  "volunteer-organization-contact",
  VolunteerOrganizationContactEntityConfig,
)
export class VolunteerOrganizationContact extends extender(
  VolunteerOrganizationContactFilters,
  VolunteerOrganizationContactMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "volunteer_organization_id" })
  volunteerOrganizationId = "";

  @Relations.toOne<VolunteerOrganizationContact, VolunteerOrganization>(
    () => VolunteerOrganization,
    "volunteerOrganizationId",
  )
  volunteerOrganization?: VolunteerOrganization;

  @Fields.string({ dbName: "role_kind", caption: "סוג תפקיד" })
  roleKind = "";

  @Fields.string({ dbName: "role_label", caption: "תפקיד" })
  roleLabel = "";

  @Fields.string({ allowNull: true, caption: "שם" })
  name?: string | null;

  @Fields.string({ allowNull: true, caption: "טלפון" })
  phone?: string | null;

  @Fields.string({ allowNull: true, caption: "מייל" })
  email?: string | null;

  @Fields.integer({ dbName: "sort_order", caption: "סדר" })
  sortOrder = 0;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
